import { usePWAInstall } from "@/hooks/usePWAInstall";
import { useIsMobile } from "@/hooks/use-mobile";
import { Button } from "@/components/ui/button";
import { Download, Share, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export function InstallPrompt() {
  const { canInstall, isInstalled, isIOS, install } = usePWAInstall();
  const isMobile = useIsMobile();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(() => 
    sessionStorage.getItem("pwa-install-dismissed") === "true"
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuthenticated(!!session?.user);
    });
    supabase.auth.getSession().then(({ data: { session } }) => {
      setIsAuthenticated(!!session?.user);
    });
    return () => subscription.unsubscribe();
  }, []);

  const employeePortalSlugs = ["/fichar", "/clock-in", "/pointage", "/ponto", "/تسجيل-حضور"];
  const isEmployeePortalRoute = employeePortalSlugs.some(
    (slug) =>
      location.pathname === slug ||
      location.pathname.startsWith(`${slug}/`) ||
      location.pathname.endsWith(slug)
  );

  // Don't show on employee portal (including localized routes)
  if (isEmployeePortalRoute) return null;
  if (!isAuthenticated) return null;
  if (!isMobile) return null;
  if (isInstalled || dismissed) return null;
  if (!canInstall && !isIOS) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem("pwa-install-dismissed", "true");
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-md rounded-xl border border-border bg-card p-4 shadow-lg animate-slide-in-up md:left-auto md:right-6 md:max-w-sm">
      <button 
        onClick={handleDismiss} 
        className="absolute right-2 top-2 rounded-full p-1 text-muted-foreground hover:bg-muted"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
          <Download className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-foreground">Instalar SCOOTERP</p>
          {isIOS ? (
            <p className="mt-1 text-xs text-muted-foreground">
              Pulsa <Share className="inline h-3 w-3" /> y luego "Añadir a pantalla de inicio"
            </p>
          ) : (
            <>
              <p className="mt-1 text-xs text-muted-foreground">
                Accede más rápido desde tu pantalla de inicio
              </p>
              <Button size="sm" className="mt-2 h-8 text-xs" onClick={install}>
                Instalar app
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
